import { createState } from '~/util/storeHelpers'

// INFO: Api Mock
const $api = {
  getSlides() {
    return new Promise((resolve) => resolve({ data: { slides: [] } }))
  },
}

const slidesState = createState({ key: 'slides' })

export const state = () => ({
  slides: slidesState.state,
})

export const mutations = {
  set_slides: slidesState.setter,
}

export const actions = {
  async fetch_smthng({ commit }) {
    commit('set_slides', { isLoading: true })
    try {
      const resp = await $api.getSlides()
      commit('set_slides', { data: resp.data })
    }
    catch (e) {
      commit('set_slides', { error: e })
    }
    finally {
      commit('set_slides', { isLoading: false })
    }
  },

  async reset_smthng({ commit }) {
    commit('set_slides', { reset: true })
  },
}

export const getters = {
  get_slides: slidesState.getter,
}
